import * as React from "react";
import { HorizontalScroll } from "../../horizontal-scroll/horizontal-scroll.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { useLabels } from "../../helpers/label-provider/use-labels.mjs";
import { Skeleton } from "../../skeleton/skeleton/skeleton.mjs";
import { SkeletonItem } from "../../skeleton/skeleton-item/skeleton-item.mjs";
import { HorizontalFilterItem } from "../horizontal-filter-item/horizontal-filter-item.mjs";
const HorizontalFilter = (props) => {
  var _a;
  const labels = useLabels();
  const defaultItemsRenderedCount = props.initiallyShown || ((_a = props.horizontalFilterItems) == null ? void 0 : _a.length);
  const [renderedItemsCount, setRenderedItemsCount] = React.useState(defaultItemsRenderedCount);
  const isExpanded = renderedItemsCount !== props.initiallyShown;
  const showAllButtonLabel = props.showAllButtonLabel || labels.get("horizontalFilter.showAll");
  const hideButtonLabel = props.hideButtonLabel || labels.get("horizontalFilter.hide");
  let firstHiddenItemId = "";
  const getFilterItems = () => {
    var _a2;
    return (_a2 = props.horizontalFilterItems) == null ? void 0 : _a2.slice(0, renderedItemsCount).map((item, index) => {
      if (defaultItemsRenderedCount === index) {
        firstHiddenItemId = item.id;
      }
      return /* @__PURE__ */ React.createElement(HorizontalFilterItem, { key: item.id, ...item });
    });
  };
  React.useEffect(() => {
    var _a2;
    (_a2 = document.getElementById(firstHiddenItemId)) == null ? void 0 : _a2.focus();
  }, [firstHiddenItemId, isExpanded]);
  const handleShowAllButtonClick = () => {
    var _a2, _b;
    if (renderedItemsCount === props.initiallyShown) {
      setRenderedItemsCount(props.horizontalFilterItems.length);
      (_a2 = props.onToggle) == null ? void 0 : _a2.call(props, true);
    } else if (props.initiallyShown) {
      setRenderedItemsCount(props.initiallyShown);
      (_b = props.onToggle) == null ? void 0 : _b.call(props, false);
    }
  };
  const BEM = () => {
    const classArray = ["horizontal-filter"];
    if (props.horizontalScroll) {
      classArray.push("is-scrollable");
    }
    return classArray.join(" ");
  };
  const renderShowAllButton = () => {
    var _a2;
    if (!props.initiallyShown || props.initiallyShown >= ((_a2 = props.horizontalFilterItems) == null ? void 0 : _a2.length)) {
      return;
    }
    return /* @__PURE__ */ React.createElement("button", { className: "horizontal-filter-item__show-all-btn", onClick: handleShowAllButtonClick, type: "button", "aria-expanded": isExpanded }, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#more", size: "xs" }), isExpanded ? hideButtonLabel : showAllButtonLabel);
  };
  return props.skeleton ? /* @__PURE__ */ React.createElement(Skeleton, { className: "horizontal-filter__skeleton", ...props.skeleton }, Array.from(Array(5).keys()).map(({}, index) => /* @__PURE__ */ React.createElement(SkeletonItem, { key: index, width: "128px", height: "48px" }))) : /* @__PURE__ */ React.createElement("div", { className: BEM(), "data-theme": props.theme }, props.horizontalScroll ? /* @__PURE__ */ React.createElement(HorizontalScroll, { scrollFadeProps: props.scrollFadeProps }, getFilterItems(), renderShowAllButton()) : /* @__PURE__ */ React.createElement(React.Fragment, null, getFilterItems(), renderShowAllButton()));
};
export {
  HorizontalFilter
};
